import { CALL_API } from '../middleware/api'

export const SYNC_ORPHANED_REQUEST = 'SYNC_ORPHANED_REQUEST'
export const SYNC_ORPHANED_SUCCESS = 'SYNC_ORPHANED_SUCCESS'
export const SYNC_ORPHANED_FAILURE = 'SYNC_ORPHANED_FAILURE'

export function fetchOrphanedRecords() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'sync/orphaned',
      authenticated: true,
      types: [SYNC_ORPHANED_REQUEST, SYNC_ORPHANED_SUCCESS, SYNC_ORPHANED_FAILURE]
    }
  }
}

export const SYNC_CUSTOMER_REQUEST = 'SYNC_CUSTOMER_REQUEST'
export const SYNC_CUSTOMER_SUCCESS = 'SYNC_CUSTOMER_SUCCESS'
export const SYNC_CUSTOMER_FAILURE = 'SYNC_CUSTOMER_FAILURE'

export function syncCustomerToAuth(customerId) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `sync/customer/${customerId}`,
      authenticated: true,
      types: [SYNC_CUSTOMER_REQUEST, SYNC_CUSTOMER_SUCCESS, SYNC_CUSTOMER_FAILURE]
    }
  }
}

export const SYNC_USER_REQUEST = 'SYNC_USER_REQUEST'
export const SYNC_USER_SUCCESS = 'SYNC_USER_SUCCESS'
export const SYNC_USER_FAILURE = 'SYNC_USER_FAILURE'

export function syncUserToAuth(userId) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `sync/user/${userId}`,
      authenticated: true,
      types: [SYNC_USER_REQUEST, SYNC_USER_SUCCESS, SYNC_USER_FAILURE]
    }
  }
}

export const SYNC_BULK_REQUEST = 'SYNC_BULK_REQUEST'
export const SYNC_BULK_SUCCESS = 'SYNC_BULK_SUCCESS'
export const SYNC_BULK_FAILURE = 'SYNC_BULK_FAILURE'

export function syncBulkToAuth() {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'sync/bulk',
      authenticated: true,
      types: [SYNC_BULK_REQUEST, SYNC_BULK_SUCCESS, SYNC_BULK_FAILURE]
    }
  }
}
